// Singleton Socket.io client instance.
// autoConnect: false — we connect/disconnect explicitly per game session.
// In dev the React app (port 3001) connects directly to the API server (port 3000).
// In production both are served from the same origin.

import { io } from 'socket.io-client';

const SERVER_URL =
  process.env.NODE_ENV === 'production'
    ? window.location.origin
    : 'http://localhost:3000';

export const socket = io(SERVER_URL, {
  autoConnect: false,
  withCredentials: true,
});
